import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type Langue = 'fr' | 'en' | 'ar';

@Injectable({
  providedIn: 'root'
})
export class LangService {

  // BehaviorSubject permet a tous les composants d'etre avertis quand la langue change.
  // On relit la langue precedemment choisie dans localStorage pour qu'elle survive
  // a un rechargement de page (F5) au lieu de toujours repartir en francais.
  private langueActuelle = new BehaviorSubject<Langue>(this.lireLangueSauvegardee());
  langue$ = this.langueActuelle.asObservable();

  constructor() {
    document.documentElement.dir = this.langueActuelle.value === 'ar' ? 'rtl' : 'ltr';
  }

  private lireLangueSauvegardee(): Langue {
    const sauvegardee = localStorage.getItem('fis_langue');
    return (sauvegardee === 'fr' || sauvegardee === 'en' || sauvegardee === 'ar') ? sauvegardee : 'fr';
  }

  changerLangue(langue: Langue): void {
    this.langueActuelle.next(langue);
    localStorage.setItem('fis_langue', langue);
    document.documentElement.dir = langue === 'ar' ? 'rtl' : 'ltr';
  }

  getLangueActuelle(): Langue {
    return this.langueActuelle.value;
  }
}
